import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map, find } from 'lodash';
import { Form, Col } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import { getOGRAttributes, getOGRLayerName } from '../../../api/Layers/layer-operations';

import LoadButton from '../LoadButton';

const LayerOGRFields = ({ layer, layerSubType, ogrLayers, geojsonLoading, loadOGRGeoJSON }) => {
  if (
    layerSubType === LAYER_SUBTYPES.OGR &&
    !(isEmpty(ogrLayers) && isEmpty(getOGRLayerName(layer)))
  ) {
    const ogrLayersArray = ogrLayers.layers || [];
    if (isEmpty(ogrLayers) && !isEmpty(getOGRLayerName(layer))) {
      ogrLayersArray.push({
        name: getOGRLayerName(layer),
        attributes: getOGRAttributes(layer).split(',')
      });
    }
    const [ogrLayerName, handleOGRLayerNameChange] = useState(getOGRLayerName(layer));
    const [selectedAttributes, handleSelectedAttributes] = useState(
      getOGRAttributes(layer).split(',')
    );

    const { attributes } = find(ogrLayersArray, ['name', ogrLayerName]) || [];
    return (
      <>
        <Form.Group>
          <Form.Label>Layer Name</Form.Label>
          <Form.Control
            as="select"
            name="ogrLayerName"
            value={ogrLayerName}
            onChange={event => handleOGRLayerNameChange(event.target.value)}
          >
            <option value="">-</option>
            {map(ogrLayersArray, ({ name }) => {
              return (
                <option value={name} key={name}>
                  {name}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
        {!isEmpty(attributes) && (
          <Form.Group>
            <Form.Label>Layer Attribute</Form.Label>
            <Form.Row>
              <Col xs={10}>
                <Form.Control
                  as="select"
                  multiple
                  name="ogrAttribute"
                  value={selectedAttributes}
                  onChange={event =>
                    handleSelectedAttributes(map(event.target.selectedOptions, 'value'))
                  }
                >
                  {map(attributes, attribute => {
                    return (
                      <option value={attribute} key={attribute}>
                        {attribute}
                      </option>
                    );
                  })}
                </Form.Control>
              </Col>
              <Col xs={2}>
                <LoadButton isLoading={geojsonLoading} clickAction={loadOGRGeoJSON} />
              </Col>
            </Form.Row>
          </Form.Group>
        )}
      </>
    );
  }
  return '';
};
LayerOGRFields.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  ogrLayers: PropTypes.object.isRequired,
  loadOGRGeoJSON: PropTypes.func.isRequired,
  geojsonLoading: PropTypes.bool.isRequired
};

export default LayerOGRFields;
